import AnimationOptions from "../AnimationOptions";

export default class FadeToColorOptions extends AnimationOptions {
    /**
     * 
     * @param {string} color the color to fill the screen for the transition
     * @param {number} colorWait the wait time before the color fades out
     * @param {number} delay delay before the animation starts
     * @param {number} duration combined duration of the color fade in and out animations
     * @param {Function} ease ease function for the color fade in and out animations
     * @param {Array<Function>|Function} completedCallbacks 
     * @param {Array<Function>} colorFadedInCallbacks 
     */
    constructor(color = "#000000", colorWait = 0.5, delay = 0, duration = 1, ease = createjs.Ease.linear, completedCallbacks = [], colorFadedInCallbacks = []) {
        super(delay, duration, ease, completedCallbacks);

        this.color = color;
        this.colorWait = colorWait;
        this.colorFadedInCallbacks = colorFadedInCallbacks;
    }
}